export default "icons/edit.svg"